import Extinguisher from '@/models/Extinguisher'
import User, { hasRole, Role } from '@/models/User'

export default class ExtinguisherPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, extinguisher: Extinguisher) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === extinguisher.entry.catalog.company.id
			case Role.AUDITOR:
				return extinguisher.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, extinguisher: Extinguisher) {
		return hasRole(user, Role.USER) && user.company?.id === extinguisher.entry.catalog.company.id
	}

	restore(user: User, extinguisher: Extinguisher) {
		return hasRole(user, Role.USER) && user.company?.id === extinguisher.entry.catalog.company.id
	}

	delete(user: User, extinguisher: Extinguisher) {
		return hasRole(user, Role.USER) && user.company?.id === extinguisher.entry.catalog.company.id
	}

	forceDelete(_user: User, _extinguisher: Extinguisher) {
		return false
	}
}
